import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pos-session-close',
  templateUrl: './pos-session-close.component.html',
  styleUrls: ['./pos-session-close.component.css']
})
export class PosSessionCloseComponent implements OnInit {

  private dp = [];
  no = '';
  displayedColumns = ['type', 'close_sys', 'close_actual'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  cashier_name;

  model = {
    'table_name': 'pos_session', 'close_time': '', 
    'cashier_close': this.applicationConstants.user_info.casher_acct_number,
    'cash_close_sys': '', 'bank_close_sys': '', 'coupon_close_sys': '', 'cash_close_actual': '',
    'bank_close_actual': '', 'coupon_close_actual': '', 'reason': ''
  };

  Success_Msg; Error_Msg; Cash; Bank; Coupons;
  Not_Counter_Msg; Cash_Msg; Bank_Msg; Coupon_Msg; 

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService, private route: ActivatedRoute) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    this.cashier_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_info['name'] : this.applicationConstants.user_info['name_en']);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Coupons').subscribe((res: string) => {
      this.Coupons = res;
    });

    translate.get('Cash_Msg').subscribe((res: string) => {
      this.Cash_Msg = res;
    });

    translate.get('Bank_Msg').subscribe((res: string) => {
      this.Bank_Msg = res;
    });

    translate.get('Coupon_Msg').subscribe((res: string) => {
      this.Coupon_Msg = res;
    }); 

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });
  }

  ngOnInit() {
    if (this.applicationConstants.user_info['role'] == 'casher')
      this.displayedColumns = ['type', 'close_actual'];
    
    this.route.params.subscribe(params => {
      this.no = params['no'];
      let query, obj;

      query = "SELECT * FROM `pos_session` WHERE `status` = '1' AND `session_no` = '" + this.no + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let result = data.data['list'];
          let cash_total = Number(result['0']['cash_open']);
          let bank_total = Number(result['0']['bank_open']);
          let coupon_total = Number(result['0']['coupon_open']);

          // get cash amount
          query = "SELECT COALESCE(SUM(`amount`), 0) AS 'cash_total' FROM `acct_log` WHERE `log_date` >= '" + 
            result['0']['start_time'] + "' AND `acct_number` = '" + result['0']['cashier'] + "' AND `status` = '1'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              cash_total += Number(data.data['list'][0]['cash_total']);

              // ge bank amount
              query = this.queryList.all_bank + " LIMIT 1";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.data['list'].length > 0) {
                    let bank_acct_number = data.data['list'][0]['acct_number'];

                    query = "SELECT COALESCE(SUM(`amount`), 0) AS 'bank_total' FROM `acct_log` WHERE `log_date` >= '" + 
                      result['0']['start_time'] + "' AND `acct_number` = '" + bank_acct_number + "' AND `status` = '1'";
                    obj = { cmd: 'getList', query: query };

                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();
                        bank_total += Number(data.data['list'][0]['bank_total']);

                        if (this.applicationConstants.user_info['role'] != 'casher') {
                          this.dp = [{ 'id': 'cash', 'type': this.Cash, 'close_sys': cash_total.toFixed(2), 
                            'close_actual': cash_total.toFixed(2) },
                            { 'id': 'bank', 'type': this.Bank, 'close_sys': bank_total.toFixed(2), 
                            'close_actual': bank_total.toFixed(2) },
                            { 'id': 'coupon', 'type': this.Coupons, 'close_sys': coupon_total.toFixed(2), 
                            'close_actual': coupon_total.toFixed(2) }];
                        }
                        else {
                          this.dp = [{ 'id': 'cash', 'type': this.Cash, 'close_sys': '0', 
                            'close_actual': '0' },
                            { 'id': 'bank', 'type': this.Bank, 'close_sys': '0', 
                            'close_actual': '0' },
                            { 'id': 'coupon', 'type': this.Coupons, 'close_sys': '0', 
                            'close_actual': '0' }];
                        }

                        this.dataSource = new MatTableDataSource(this.dp);
                        this.dataSource.sort = this.sort;

                        this.model['cash_close_sys'] = cash_total.toFixed(2);
                        this.model['bank_close_sys'] = bank_total.toFixed(2);
                        this.model['coupon_close_sys'] = coupon_total.toFixed(2);
                      });
                  }
                  else {
                    this.dp = [{ 'id': 'cash', 'type': this.Cash, 'close_sys': cash_total.toFixed(2), 
                      'close_actual': cash_total.toFixed(2) },
                      { 'id': 'bank', 'type': this.Bank, 'close_sys': bank_total.toFixed(2), 
                      'close_actual': bank_total.toFixed(2) },
                      { 'id': 'coupon', 'type': this.Coupons, 'close_sys': coupon_total.toFixed(2), 
                      'close_actual': coupon_total.toFixed(2) }];
      
                    this.dataSource = new MatTableDataSource(this.dp);
                    this.dataSource.sort = this.sort;

                    this.model['cash_close_sys'] = cash_total.toFixed(2);
                    this.model['bank_close_sys'] = bank_total.toFixed(2);
                    this.model['coupon_close_sys'] = coupon_total.toFixed(2);
                  }
                });
            
              // console.log(cash_total);
              // log_result.forEach(element => {
              //   cash_total += Number(element.amount);
              // });
            });
        });
    });
  }

  save() {
    if (this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      return;
    }

    this.model['cash_close_actual'] = (document.getElementById('close_actual_cash') as HTMLInputElement).value;
    this.model['bank_close_actual'] = (document.getElementById('close_actual_bank') as HTMLInputElement).value;
    this.model['coupon_close_actual'] = (document.getElementById('close_actual_coupon') as HTMLInputElement).value;

    if (this.model['cash_close_actual'] == '') {
      alert(this.Cash_Msg);
      return;
    }
      
    if (this.model['bank_close_actual'] == '') {
      alert(this.Bank_Msg);
      return;
    }
      
    if (this.model['coupon_close_actual'] == '') {
      alert(this.Coupon_Msg);
      return;
    }
      
    let today = new Date();
    this.model['close_time'] = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" +
      today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

    let values = [];
    values.push(this.model);

    let where = [{ 'session_no': this.no }];
    let obj = { cmd: 'update', values: values, where: where };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.router.navigate(['sub_menu/1/pos_session_list']);
        }
        else 
          alert(this.Error_Msg);
      });
  }

}
